import { Pipe, PipeTransform } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Autolinker } from 'autolinker';

@Pipe({
  name: 'linkify',
})
export class LinkifyPipe implements PipeTransform {
  transform(html: string): SafeResourceUrl {
    if (!html || String(html).length < 10) {
      return html;
    }

    return Autolinker.link(html, {
      urls: {
        schemeMatches: true,
        wwwMatches: true,
        tldMatches: true,
      },
      email: false,
      phone: false,
      stripTrailingSlash: true,
      newWindow: true,

      truncate: {
        length: 35,
        location: 'smart',
      },
      className: 'crm-link',
    });
  }
}
